import { motion } from "framer-motion";
import styled from "styled-components";

export const Container = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
  padding: 20px;
  padding-top: 4rem;
`;

export const PageHeader = styled.div`
  text-align: center;
  margin-bottom: 3rem;
`;

export const PageTitle = styled.h1`
  color: #ff6b35;
  font-size: 3rem;
  margin-bottom: 1rem;
  line-height: 3rem;
  font-weight: bold;
  background: linear-gradient(135deg, #ff6b35, #ff8c42);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;

export const PageSubtitle = styled.p`
  color: #cccccc;
  font-size: 1.2rem;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
`;
export const Section = styled.section`
  background: #1a1a1a;
  border-radius: 15px;
  padding: 3rem;
  margin-bottom: 3rem;
  border: 1px solid #333;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="25" cy="25" r="0.8" fill="%23ff6b35" opacity="0.08"/><circle cx="75" cy="75" r="1" fill="%23ff6b35" opacity="0.08"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>');
    opacity: 0.5;
    z-index: 1;
  }

  > * {
    position: relative;
    z-index: 2;
  }
`;

export const SectionTitle = styled.h2`
  color: #ff6b35;
  font-size: 2.5rem;
  margin-bottom: 2rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 1rem;
  @media (max-width: 768px) {
    text-align: center;
    flex-direction: column;
  }
`;

export const SectionText = styled.p`
  color: #cccccc;
  font-size: 1.1rem;
  line-height: 1.7;
  margin-bottom: 2rem;
  @media (max-width: 768px) {
    text-align: center;
  }
`;

export const TwoColumnLayout = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  margin-top: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`;

export const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 2rem;
  margin: 2rem 0;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const StatCard = styled(motion.div)`
  background: #2c2c2c;
  border: 1px solid #444;
  border-radius: 12px;
  padding: 2rem;
  text-align: center;
  transition: all 0.3s ease;

  &:hover {
    border-color: #ff6b35;
    transform: translateY(-5px);
    box-shadow: 0 10px 25px rgba(255, 107, 53, 0.2);
  }
`;

export const StatIcon = styled.div`
  color: #ff6b35;
  font-size: 2.5rem;
  margin-bottom: 1rem;
  display: flex;
  justify-content: center;
`;

export const StatNumber = styled.div`
  color: #ffffff;
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
`;

export const StatLabel = styled.div`
  color: #cccccc;
  font-size: 1rem;
  font-weight: 500;
`;

export const TeamGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin-top: 2rem;
`;

export const TeamCard = styled(motion.div)`
  background: #2c2c2c;
  border: 1px solid #444;
  border-radius: 12px;
  padding: 2rem;
  text-align: center;
  transition: all 0.3s ease;

  &:hover {
    border-color: #ff6b35;
    transform: translateY(-5px);
  }
`;

export const TeamAvatar = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ff6b35, #ff8c42);
  margin: 0 auto 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  font-weight: bold;
  color: #ffffff;
`;

export const TeamName = styled.h3`
  color: #ffffff;
  font-size: 1.3rem;
  margin-bottom: 0.5rem;
  font-weight: bold;
`;

export const TeamRole = styled.p`
  color: #ff6b35;
  font-size: 1rem;
  margin-bottom: 1rem;
  font-weight: 500;
`;

export const TeamDescription = styled.p`
  color: #cccccc;
  font-size: 0.9rem;
  line-height: 1.5;
`;

export const ContactGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
  margin-top: 2rem;
`;

export const ContactCard = styled.div`
  background: #2c2c2c;
  border: 1px solid #444;
  border-radius: 12px;
  padding: 2rem;
  transition: all 0.3s ease;

  &:hover {
    border-color: #ff6b35;
    transform: translateY(-2px);
  }
`;

export const ContactIcon = styled.div`
  color: #ff6b35;
  font-size: 2rem;
  margin-bottom: 1rem;
`;

export const ContactTitle = styled.h3`
  color: #ffffff;
  font-size: 1.2rem;
  margin-bottom: 1rem;
  font-weight: bold;
`;

export const ContactInfo = styled.div`
  color: #cccccc;
  line-height: 1.6;

  a {
    color: #ff6b35;
    text-decoration: none;
    transition: color 0.3s ease;

    &:hover {
      color: #ff8c42;
    }
  }
`;

export const ContactForm = styled.form`
  background: #2c2c2c;
  border: 1px solid #444;
  border-radius: 12px;
  padding: 2rem;
  margin-top: 2rem;
`;

export const FormTitle = styled.h3`
  color: #ff6b35;
  font-size: 1.5rem;
  margin-bottom: 1.5rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-bottom: 1rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const FormGroup = styled.div`
  margin-bottom: 1rem;
`;

export const FormLabel = styled.label`
  display: block;
  color: #ffffff;
  font-weight: bold;
  margin-bottom: 0.5rem;
`;

export const FormInput = styled.input`
  width: 100%;
  background: #1a1a1a;
  border: 1px solid #444;
  border-radius: 8px;
  padding: 0.8rem;
  color: #ffffff;
  font-size: 1rem;
  transition: border-color 0.3s ease;

  &:focus {
    outline: none;
    border-color: #ff6b35;
  }

  &::placeholder {
    color: #666;
  }
`;

export const FormTextarea = styled.textarea`
  width: 100%;
  background: #1a1a1a;
  border: 1px solid #444;
  border-radius: 8px;
  padding: 0.8rem;
  color: #ffffff;
  font-size: 1rem;
  min-height: 120px;
  resize: vertical;
  transition: border-color 0.3s ease;

  &:focus {
    outline: none;
    border-color: #ff6b35;
  }

  &::placeholder {
    color: #666;
  }
`;

export const SubmitButton = styled.button`
  background: #ff6b35;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  padding: 1rem 2rem;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  &:hover {
    background: #e55a2b;
    transform: translateY(-2px);
  }
`;

export const SocialSection = styled.div`
  text-align: center;
  margin-top: 3rem;
`;

export const SocialTitle = styled.h3`
  color: #ff6b35;
  font-size: 1.5rem;
  margin-bottom: 1rem;
  font-weight: bold;
`;

export const SocialLinks = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 1rem;
`;

export const SocialLink = styled.a`
  background: #2c2c2c;
  color: #cccccc;
  padding: 1rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  transition: all 0.3s ease;
  text-decoration: none;
  border: 1px solid #444;

  &:hover {
    background: #ff6b35;
    color: #ffffff;
    transform: translateY(-3px);
    border-color: #ff6b35;
  }
`;

export const ValuesList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
  margin-top: 2rem;
`;

export const ValueItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1rem;
  background: #2c2c2c;
  border-radius: 10px;
  border: 1px solid #444;
  transition: all 0.3s ease;

  &:hover {
    border-color: #ff6b35;
    transform: translateX(5px);
  }
`;

export const ValueIcon = styled.div`
  color: #ff6b35;
  font-size: 1.5rem;
  margin-top: 0.2rem;
`;

export const ValueContent = styled.div`
  flex: 1;
`;

export const ValueTitle = styled.h4`
  color: #ffffff;
  font-size: 1.1rem;
  margin-bottom: 0.5rem;
  font-weight: bold;
`;

export const ValueDescription = styled.p`
  color: #cccccc;
  font-size: 0.9rem;
  line-height: 1.5;
`;

export const ContactCardStyled = styled.div`
  background: linear-gradient(145deg, #2c2c2c 0%, #1a1a1a 100%);
  border: 1px solid #444;
  border-radius: 20px;
  padding: 2rem;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 3px;
    background: linear-gradient(90deg, #ff6b35, #e55a2b);
    border-radius: 20px 20px 0 0;
  }

  &:hover {
    border-color: #ff6b35;
    transform: translateY(-8px);
    box-shadow: 0 20px 40px rgba(255, 107, 53, 0.2);
  }

  @media (max-width: 768px) {
    padding: 1.5rem;
  }
`;

export const ContactIconStyled = styled.div`
  color: #ff6b35;
  font-size: 2.5rem;
  margin-bottom: 1rem;
  animation: pulse 2s infinite;

  @keyframes pulse {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.7;
    }
  }
`;

export const ContactTitleStyled = styled.h3`
  color: #ffffff;
  font-size: 1.4rem;
  margin-bottom: 1.5rem;
  font-weight: bold;
  letter-spacing: 0.5px;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    bottom: -8px;
    left: 0;
    width: 50px;
    height: 2px;
    background: linear-gradient(90deg, #ff6b35, #e55a2b);
    border-radius: 2px;
  }
`;

export const ContactInfoStyled = styled.div`
  color: #cccccc;
  line-height: 1.8;
  font-size: 1rem;

  br {
    margin-bottom: 0.5rem;
  }

  a {
    color: #ff6b35;
    text-decoration: none;
    transition: all 0.3s ease;
    font-weight: 500;

    &:hover {
      color: #ff8c42;
      text-shadow: 0 0 8px rgba(255, 107, 53, 0.3);
    }
  }
`;
